import React from 'react';
import CloseIcon from 'svg/CloseIcon';
import InfoCircle from 'svg/InfoCircle';
import { ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

const steps = [
  {
    number: '1.',
    description: 'Upload more',
    highlight: 'photos',
    rest: ' and ',
    highlight2: 'videos',
    rest2: ' of you coaching.',
  },
  {
    number: '2.',
    description: 'Fill the section',
    highlight: 'About you.',
  },
  {
    number: '3.',
    description: 'Add',
    highlight: 'social media',
    rest: ' links.',
  },
];

interface CompleteListingGuideModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const CompleteListingGuideModal: React.FC<CompleteListingGuideModalProps> = ({
  isOpen,
  handleClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      classNameMaxWidth="sm:max-w-2xl"
      classNameRounded="rounded-3xl"
    >
      <div className="flex flex-col">
        {/* Modal Header */}
        <div className="flex flex-row items-center justify-between border-b border-color-border-card-lightmode px-10 py-5 dark:border-color-border-card-darkmode max-sm:px-ds-lg">
          <div className="flex flex-row items-center gap-4">
            <div className="h-6 w-6">
              <InfoCircle className="h-full w-full text-color-text-lightmode-primary dark:text-color-text-darkmode-primary" />
            </div>
            <h2 className="typography-product-heading-desktop max-sm:typography-product-heading-mobile">
              Complete your listing
            </h2>
          </div>
          <ButtonText onClick={handleClose}>
            <CloseIcon className="h-6 w-6 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary max-sm:h-3.5 max-sm:w-3.5" />
          </ButtonText>
        </div>

        {/* Modal Content */}
        <div className="flex flex-col items-center px-10 py-4 pb-8 max-sm:px-ds-lg">
          <div className="flex w-full flex-col gap-6">
            {/* Introduction */}
            <p className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              A complete listing builds trust and attracts more clients. Add photos, videos, and
              social links to showcase your personality, and fill in your story so clients know why
              you're the right coach for them.
            </p>

            {/* Steps */}
            <div className="flex flex-col gap-3">
              {steps.map((step, index) => (
                <div key={index} className="flex flex-row items-start gap-3">
                  <span className="typography-product-body-highlight flex-shrink-0 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                    {step.number}
                  </span>
                  <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                    {step.description}{' '}
                    <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                      {step.highlight}
                    </span>
                    {step.rest && (
                      <>
                        {step.rest}
                        {step.highlight2 && (
                          <span className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                            {step.highlight2}
                          </span>
                        )}
                      </>
                    )}
                    {step.rest2}
                  </p>
                </div>
              ))}
            </div>

            {/* Visual Guide */}
            <img src="/images/coaches/complete-listing-guide.png" alt="Complete Listing Guide" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CompleteListingGuideModal;
